import React from 'react';

import ListItemDetails from './ListItemDetails.jsx';

import { countQualifications } from './functions.js';

// superclass list item
// props - id, title (name of superclass), and qualifications (subjects)
// limited interactivity - control display of its own qualifications
var ListItem = React.createClass({

    getInitialState: function() {

        return({
            expanded : false
        });

    },

    render: function(){

        var component = this;

        //console.log(this.props);

        var qualificationsCount = countQualifications(this.props.subjects);

        if ( this.state.expanded == false && !( this.props.superclasses < 3 || this.props.count < 10 ) ) {

            return (
                <li className="list--item" >
                    <a href="#" className="clearfix" onClick={ this.toggle } >
                        <span className="list--item--title">{ this.props.title }</span>
                        <span className="list--item--count">{ qualificationsCount } qualifications</span>
                    </a>
                </li>
            );

        }

        else {

            return (
                <li className="list--item active">
                    <a href="#" className="active clearfix" onClick={ this.toggle }>
                        <span className="list--item--title">{ this.props.title }</span>
                        <span className="list--item--count">{ qualificationsCount } qualifications</span>
                    </a>
                    <ListItemDetails
                        id = { this.props.id }
                        subjects = { this.props.subjects }
                        filteredText = { component.props.filteredText }
                    />
                </li>
            );

        }

    },

    toggle : function(e){

        e.preventDefault();

        if ( this.state.expanded == false ) this.setState({expanded: true});

        else if ( this.state.expanded == true ) this.setState({expanded: false});

    }

});


export default ListItem;


/** WEBPACK FOOTER **
 ** ./app/ListItem.jsx
 **/